$(document).ready(function () {
  $('.show-navbar-custom').on("click", function() {
    $('.mobile-navbar').addClass('d-block');
  });
  $('.hide-navbar-custom').on("click", function() {
    $('.mobile-navbar').removeClass('d-block');
  });
});
